import { observer } from "mobx-react-lite";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import BriaButton from "../../../../components/common/BriaButton/BriaButton.tsx";
import AutomotiveBestPracticesPopup from "../../Popups/AutomotiveBestPracticesPopup/AutomotiveBestPracticesPopup.tsx";

type IProps = {
	type?: "primary" | "secondaryMedium";
	className?: any;
};
const AutomotiveBestPracticesButton = ({ type = "secondaryMedium", className }: IProps) => {
	const { t } = useTranslation("translation", { keyPrefix: "automotiveApp" });
	const [openBestPracticesPopup, setOpenBestPracticesPopup] = useState(false);

	return (
		<>
			<BriaButton buttonType={type} className={className} onClick={() => setOpenBestPracticesPopup(true)}>
				{t("bestPractices")}
			</BriaButton>
			<AutomotiveBestPracticesPopup
				open={openBestPracticesPopup}
				onClose={() => setOpenBestPracticesPopup(false)}
			/>
		</>
	);
};

export default observer(AutomotiveBestPracticesButton);
